module.exports = __webpack_public_path__ + "img/wenzi1.f9338eea.webp";